export default __webpack_public_path__ + "static/media/Classwin-onlineCourse-blue.fb6e2827.svg";